import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";
import { BottomSheet } from "react-spring-bottom-sheet";
import comment from "../assets/comment.png";
import like from "../assets/like.png";
import play from "../assets/play.svg";
import { useParams } from "react-router";
import { VIDEO_DETAILS } from "../constants/urls";
import ProfileDownloadIcon from "../components/mobile/ProfileDownloadIcon";
import FollowButtonProfilePic from "../components/mobile/FollowButtonProfilePic";
import Navbar from "../components/desktop/Navbar";
import VideoCard from "../components/desktop/VideoCard";
import BlueSticker from "../components/desktop/BlueSticker";
import DownloadBottomSheet from "../components/mobile/DownloadBottomSheet";
import { Swiper, SwiperSlide } from "swiper/react";
import "react-spring-bottom-sheet/dist/style.css";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import SwiperCore, { Pagination } from "swiper/core";
import Modal from "react-modal";
import BlueButton from "../components/desktop/BlueButton";
import Stories from 'react-insta-stories';
import stickers from '../assets/stickers.svg';
import square_cat from "../assets/glip_square.svg";
import input_bar from "../assets/input_bar.svg";


// install Swiper modules
SwiperCore.use([Pagination]);

const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 96vh;
    flex-direction: column;
  }
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }
`;

const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow: hidden;
`;

const VideoDetails = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 16px;
`;

const BannerSpan = styled.span`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.2px;
  color: #FFFFFF;
  margin-bottom: 6px;
`;

const BannerSpanSubtitle = styled.span`
  font-family: 'Inter';
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  /* color: #7A7F9E; */
  color: #FFFFFF;
  opacity: 0.8;
`;

const VideoDetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  max-width: 60%;
`;

const CTASection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  z-index: 1;
`;

const UserName = styled.div`
  font-size: 20px;
  font-weight: 600;
  font-family: "Poppins";
  padding-bottom: 8px;
  z-index: 1;
`;

const Caption = styled.div`
  font-weight: 500;
  font-size: 16px;
  font-family: "Inter";
`;

const BlueBanner = styled.a`
  background: linear-gradient(254.06deg, #59c5e8 -33.43%, #5a8ef1 113.89%);
  background: linear-gradient(180deg, #59AAFA 0%, #326BFF 100%);
  background: rgba(14, 15, 24, 1);
  background: linear-gradient(90.07deg, #3999F9 29.06%, #4A7DFF 96.96%);
  font-family: "Inter";
  padding: 12px 16px;
  margin: 16px 0px;
  margin-top: 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const VideoHolder = styled.video`
  transform: scale(2.5);
  display: flex;
  height: 50vh;
`;

const Container = styled.div`
  padding: 12px 120px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  height: 100vh;
`;

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(21, 21, 29, 1)",
    background: "linear-gradient(180deg, #59AAFA 0%, #326BFF 100%)",
    borderWidth: 0,
    padding: "62px 62px",
    height: "214px",
    width: "340px",
    display: "flex",
    justifyContent: "space-evenly",
    flexDirection: "column",
    alignItems: "center",
  },
};

const CtaButton = ({ count, img }) => {
  return (
    <a
      onClick={() => {
        setOpen(true);
        console.log(open);
        window.analytics.track('modal_open_cta_clicked', {
          icon: `${img}`,
        })
        
      }}
      style={{ textAlign: "center" }}
    >
      <img src={img} />
      <div style={{ textAlign: "center", marginBottom: 16 }}>{count}</div>
    </a>
  );
};

export default function ClipPage(props) {
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [data, dataSet] = useState();
  const [videos, videosSet] = useState([]);
  const [video, videoSet] = useState([]);
  const [users, usersSet] = useState({});
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [pause, setPause] = useState(false) 

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }

  const { videoId } = useParams();

  useEffect(() => {
    async function fetchMyAPI() {
      let response = await fetch(VIDEO_DETAILS + videoId);
      response = await response.json();
      console.log(response);

      const videos = [];
      videos.push(response.data.video);
      response.data.otherVideos.map((item) => videos.push(item));
      videosSet(videos);
      usersSet(response.data.users);
      videoSet(response.data.video);
      dataSet(response.data);
    }

    fetchMyAPI();
  }, []);

  

  useEffect(() => {
    // if (data) {
    //     console.log('asdasd')
    //   var vid = document.getElementsByTagName('video')[0]
    //   console.log('asdasd', vid)
    //   setTimeout(() => {
    //     // vid.pause();
    //     // setPause(true);
    //     vid.click()
    //   }, 400)
      
    // }
  }, [data]);

  useEffect(() => {
    if (data) {
      var vid = document.getElementsByClassName(`video-0`)[0];
      // vid.play();
    }
  }, [data]);

  if (!data) {
    return <></>;
  }

  const list = videos.map((item, index) => {
    var pause = true;
    if (index == activeIndex) pause = false;
    return (
      // <SwiperSlide key={index}>
        <VideoContainer>
          <div style={{display: 'flex'}} className={`video-container-${index}`}>
          <img
            style={{
              zIndex: 10,
              width: 40,
              height: 40,
              alignSelf: "center",
              top: 240,
              position: "relative",
              left: '43%',
              pointerEvents: 'none'
            }}
            className={'mobile-play-icon'}
            src={play}
            // onClick=
          />
          </div>
          <VideoHolder
            className={`video-player-mobile video-${index}`}
            onClick={(e) => {e.target.play();document.getElementsByClassName('mobile-play-icon')[0].style.display = 'none'}}
            src={item.videoUri}
            autoPlay={false}
            paused={pause}
            loop={true}
            // muted
            // controls
          />
          <div>
            <VideoDetails>
              <VideoDetailsSection>
                <UserName>@{users[item.user].username}</UserName>
                <Caption>{item.caption}</Caption>
              </VideoDetailsSection>
              <CTASection>
                <div
                  style={{ display: "contents" }}
                  onClick={() => setOpen(true)}
                >
                  <FollowButtonProfilePic img={users[item.user].pictureUri} />
                </div>
                <CtaButton img={like} count={item.likes} />
                <CtaButton img={comment} count={item.comments} />
              </CTASection>
            </VideoDetails>
            <BlueBanner
              onClick={() => {
                window.analytics.track('download_button_pressed', {
                  from: 'bottom-sheet',
                  type: 'mobile'
                }) 
              }}
              href={
                "https://play.google.com/store/apps/details?id=glip.gg&hl=en_IN&gl=US"
              }
            >
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <BannerSpan>Explore more clips by @{users[item.user].username}</BannerSpan>
                <BannerSpanSubtitle>
                  Download app now
                </BannerSpanSubtitle>
              </div>
              <ProfileDownloadIcon
                img={users[item.user].pictureUri}
              ></ProfileDownloadIcon>
            </BlueBanner>
          </div>
        </VideoContainer>
      // </SwiperSlide>
    );
  });

  const desktop_list = videos.map((item, index) => {
    return (
      <VideoCard
        key={index}
        openModal={openModal}
        video={item}
        user={users[item.user]}
      />
    );
  });

  const stories = videos.map((item, index) => {
    const now = new Date();
    const video_created = new Date(item.createdAt)
    var seconds = (now.getTime() - video_created.getTime()) / 1000;
    const hours = Math.ceil(seconds/3600);
    const obj = {};
    obj['url'] = item.videoUri; 
    obj['type'] = 'video';
    obj['header'] = {
      heading: `@${users[item.user].username}`,
      profileImage: users[item.user].pictureUri,
      subheading: `${hours}h ago`
    };
    obj['storyStyles'] = {
      background: '#000',
    };
    return obj;
  });

  return (
    <>      
      <Mobile>
        {/* <div onClick={() => setOpen(true)}> */}
        {pause ?  <>
          <Stories
            stories={stories}
            width={'100%'}
            height={'100%'}
            // isPaused={true}
            // loop={true}
            onStoryEnd={() => setOpen(true)}
          />
          <img onClick={() => setOpen(true)} style={{position: 'relative', width: '100%', margin: 10, marginLeft: 16, marginBottom: 14}} src={stickers} />
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <img onClick={() => setOpen(true)} src={input_bar} style={{width: '100%'}} />
          </div>
          <BlueBanner
              onClick={() => {
                window.analytics.track('download_button_pressed', {
                  from: 'bottom-bar',
                  type: 'mobile'
                }) 
              }}
              href={
                "https://play.google.com/store/apps/details?id=glip.gg&hl=en_IN&gl=US"
              }
            >
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <BannerSpan>glip with @{users[video.user].username}</BannerSpan>{" "}
                <BannerSpanSubtitle >
                  Download android app
                </BannerSpanSubtitle>
              </div>
              <ProfileDownloadIcon
                img={users[video.user].pictureUri}
              ></ProfileDownloadIcon>
            </BlueBanner>
        {/* </div> */}
        {/* <Swiper
          direction={"vertical"}
          pagination={{
            clickable: true,
          }}
          className="mySwiper"
          onSlideChange={({ realIndex }) => {
            if (realIndex == 3) setOpen(true);
            setActiveIndex(realIndex);
            document.getElementsByClassName('mobile-play-icon')[0].style.display = 'none'
            var vids = document.getElementsByClassName("video-player-mobile");
            for (const v in vids) {
              if (v == "length") break;
              vids[v].pause();
            }
            var vid = document.getElementsByClassName(`video-${realIndex}`)[0];
            vid.play();
          }}
          style={{ height: "100%" }}
        >
          {list}
        </Swiper> */}
        <BottomSheet
          onDismiss={() => setOpen(false)}
          snapPoints={({ maxHeight }) => [296]}
          open={open}
        >
          {video.user && (
            <DownloadBottomSheet
              href={'https://play.google.com/store/apps/details?id=glip.gg&hl=en_IN&gl=US'}
              img={users[video.user].pictureUri}
            />
          )}
        </BottomSheet>
        </>
        : 
        <div 
          style={{
            backgroundImage: `url('${video.pictureUri}')`,
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '90vh',
            backgroundRepeat: 'no-repeat'
          }}
          onClick={() => {
            setPause(true);
            window.analytics.track('video_started', {
              from: 'mobile-play-clicked',
            });
          }}>
            <img
            style={{
              zIndex: 10,
              width: 40,
              height: 40,
              alignSelf: "center",
              top: '44%',
              position: "absolute",
              left: '43%',
            //   pointerEvents: 'none'
            }}
            // className={'mobile-play-icon'}
            src={play}
            // onClick=
          />
        </div>
        }
      </Mobile>
      <Desktop>
        <Navbar />
        <Container>
          <div style={{ marginRight: 40, display: "flex", flex: 1 }}>
            <BlueSticker video={video} user={users[video.user]} />
          </div>
          <div
            className={"desktop-item-list"}
            style={{
              display: "flex",
              flex: 2,
              flexDirection: "column",
              overflow: "scroll",
            }}
          >
            {desktop_list}
          </div>
        </Container>

        <Modal
          isOpen={modalIsOpen}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel=""
        >
          <ProfileDownloadIcon img={users[video.user].pictureUri} />
          <span style={{ textAlign: "center" }}>
            Sign up and throw likes <br></br> at @{users[video.user].username}
          </span>
          <span
            style={{
              textAlign: "center",
              marginTop: 4,
              opacity: 0.7,
              fontSize: 12,
            }}
          >
            Join ggTV community to browse,<br></br> create & share gaming clips
          </span>
          <br></br>
          <BlueButton
            href={
              "https://play.google.com/store/apps/details?id=glip.gg&hl=en_IN&gl=US"
            }
            onClick={() => {
              window.analytics.track('download_button_pressed', {
                from: 'modal',
                type: 'desktop'
              });
            }}
          >
            Download android app now
          </BlueButton>
        </Modal>
      </Desktop>
    </>
  );
}

// module.exports = VideoPage;
